module.exports = __webpack_public_path__ + "img/mas_buscados_2.79f38377.png";